import React from 'react'

const Overview = () => {
  return (
    <div className='flex'>
      <p className='text-center text-blue-500 font-semibold text-2xl'>Welcome Admin</p>
    </div>
  )
}

export default Overview